import React, { useMemo } from 'react';
import styled from 'styled-components';
import SlotInterface from '@solvhealth/types/interfaces/Location/Slot';
import LocationInterface from '@solvhealth/types/interfaces/Location';
import { Icons } from '@solvhealth/jigsaw-v1';
import {
  TODAY,
  TOMORROW,
} from '~/components/Search/components/Card/components/TimeSlots/components';
import Day from './components/Day';
import { isHomeHealthcareLocation, isTelemedLocation } from '~/core/util/location';
import {
  NEXT_DAY_BOOKINGS_SLOT_SELECTOR,
  shouldShowFeature,
} from '../../../../../../../core/util/customization';

export const DaysContainer = styled.div.withConfig({ componentId: 'sc-8pd1fs-0' })`
  width: 100%;
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
  height: 76px;
`;

const Root = styled.div.withConfig({ componentId: 'sc-8pd1fs-1' })`
  display: flex;
  justify-content: space-between;
`;

type Props = {
  todaySlots?: SlotInterface[];
  tomorrowSlots?: SlotInterface[];
  location: LocationInterface;
  onSlotSelect?: (slot: SlotInterface, slotIndex: number) => void;
  isPartOfAbTestGroup?: boolean;
  isSrp?: boolean;
  className?: string;
};

const Preview = (props: Props) => {
  const { todaySlots, tomorrowSlots, location, onSlotSelect, isSrp, className } = props;
  const labelIcon = useMemo(() => {
    if (isTelemedLocation(location)) return <Icons.VideoCamera mr={0.5} />;
    if (isHomeHealthcareLocation(location)) return <Icons.Ambulance mr={0.5} />;
    return null;
  }, [location.id]);

  return (
    <Root className={className}>
      <DaysContainer>
        <Day
          isSrp={isSrp}
          label={TODAY}
          labelIcon={labelIcon}
          location={location}
          onSlotSelect={onSlotSelect}
          todaySlots={todaySlots}
          tomorrowSlots={tomorrowSlots}
        />
        {shouldShowFeature(NEXT_DAY_BOOKINGS_SLOT_SELECTOR, location) && (
          <Day
            isSrp={isSrp}
            label={TOMORROW}
            labelIcon={labelIcon}
            location={location}
            onSlotSelect={onSlotSelect}
            todaySlots={todaySlots}
            tomorrowSlots={tomorrowSlots}
          />
        )}
      </DaysContainer>
    </Root>
  );
};

export default Preview;
